import translations from './translations'

translations.add('es', {
    invalidCvv: 'Introduzca un código de seguridad válido',
    pleaseEnter: 'Introduzca:',
    backCardList: 'Volver a la lista de tarjetas'
})
